import {
  FormEnums,
  NewFormButtonText,
} from "app/services/api/types/forms/enums/FormEnums";
import { Accordion } from "ui/gluestack/accordion";
import { View } from "react-native";
import Pagination from "ui/molecules/pagination/Pagination";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { AssessmentAccordionPreview } from "app/features/reporting/organisms/AssessmentAccordionPreview";
import { useFormHistoryWithOffline } from "app/features/offline/hooks/useFormHistoryWithOffline";
import { NoItemsComponent } from "ui/atoms/noItems";
import { AssessmentEntryEditProvider } from "app/features/assessments/providers";

interface Props {
  tag?: FormEnums;
  residentId?: number;
  formId?: number;
}
export function AssessmentHistoryTemplate({ tag, residentId, formId }: Props) {
  const { data, meta, isLoading, handlePageChange } = useFormHistoryWithOffline(
    { tag, residentId, formId },
  );

  if (isLoading) return <LoadingSpinner />;

  return (
    <AssessmentEntryEditProvider>
      <View>
        <Accordion
          type="single"
          variant="filled"
          className="mb-4"
          defaultValue={[`${data?.[0]?.id}`]}
        >
          {data?.map((item) => (
            <AssessmentAccordionPreview form={item} key={item.id} />
          ))}
          {!data?.length && !isLoading ? (
            <NoItemsComponent
              className="py-5"
              subtitle={`No reports listed.${tag && NewFormButtonText[tag] ? ` Click on "${NewFormButtonText[tag]}" to create your first report` : ""}`}
            />
          ) : null}
        </Accordion>
        <Pagination meta={meta} onPageChange={handlePageChange} />
      </View>
    </AssessmentEntryEditProvider>
  );
}
